import { api } from "@/api/client";
import type { InstituicaoInteracao } from "@/features/instituicao-interacao/api";

export interface HealthScoreDetalhe {
  login?: number;
  idosos?: number;
  evolucoes?: number;
  medicamentos?: number;
  estoque?: number;
  financeiro?: number;
  inadimplencia?: number;
}

export interface OnboardingCards {
  healthScore?: number;
  quantidadeUsuarios?: number;
  quantidadeProfissionais?: number;
  quantidadeMedicamentos?: number;
  quantidadeIdosos?: number;
  quantidadeEvolucoes?: number;
  quantidadeAtrasadas?: number;
  hsDto?: HealthScoreDetalhe;
}

export async function getInteracoesInstituicao(instituicaoId: number): Promise<InstituicaoInteracao[]> {
  const { data } = await api.get<InstituicaoInteracao[]>(`instituicao/InstituicaoInteracao/Instituicao/${instituicaoId}`);
  return data;
}

export async function getOnboardingCards(instituicaoId: number): Promise<OnboardingCards> {
  const { data } = await api.get<OnboardingCards>(`relatorio/Onboarding/Painel/${instituicaoId}`);
  return data;
}
